// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.NewArrivals.Correlated.View'
,	[
		'item_relations_cell.tpl',
		'item_relations_row.tpl',
		'facets_items_collection.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
		'ItemRelations.RelatedItem.View',
		'Tracker',
		'Utils',
		'C3.ShoppingExtensions.NewArrivals.Correlated.Collection',
		'Backbone.CollectionView',
		'Backbone'
    ]
, function (
	item_relations_cell_tpl,
	item_relations_row_tpl,
	facets_items_collection_tpl,
    facets_items_collection_view_cell_tpl,
    facets_items_collection_view_row_tpl,
	ItemRelationsRelatedItemView,
	Tracker,
	Utils,
	ItemRelationsCorrelatedCollection,
	BackboneCollectionView,
	Backbone
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return BackboneCollectionView.extend({

		initialize: function (options) {

        //console.log(this.options.itemsIds)
            
		const { siteSettings } = this.options.application.getConfig();
        const is_sca_advanced = siteSettings.sitetype === 'ADVANCED';
        const collection = is_sca_advanced
            ? new ItemRelationsCorrelatedCollection({ itemsIds: this.options.itemsIds })
            : new Backbone.Collection();

        BackboneCollectionView.prototype.initialize.call(this, {
            collection: collection,
            viewsPerRow: 4,
           /* cellTemplate: item_relations_cell_tpl,
            rowTemplate: item_relations_row_tpl,*/
            cellTemplate: facets_items_collection_view_cell_tpl,
            rowTemplate : facets_items_collection_view_row_tpl,
            childView: ItemRelationsRelatedItemView,
            template: facets_items_collection_tpl
        });

        this.view_tracked = false;

        if (is_sca_advanced) {
            this.once('afterCompositeViewRender', this.loadRelatedItems, this);
        }
		},

		loadRelatedItems: function loadRelatedItems() {
        const self = this;

        self.collection.fetchItems().done(function() {
            if (self.collection.length) {
                if (!self.view_tracked) {
                    Tracker.getInstance().trackProductListEvent(
                        self.collection,
                        'Correlated Items'
                    );
                    self.view_tracked = true;
                }
            }

            self.render();

            /*setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');

                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }

                Utils.initBxSlider(carousel, bxSliderDefaults);
            });*/
        });
    }

	});
});
